/* Svensk katalog for locale-autopilot-no.js (del 2 av 2).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('sv', {
  'ap.monthControl.edit.supplierInvoice': 'Ändra leverantörsfaktura',
  'ap.monthControl.edit.fallbackWithLabel': 'Ändra {{label}}',
  'ap.monthControl.edit.fallback': 'Ändra',
  'ap.monthControl.vatAmount': 'Moms {{amount}}',
  'ap.monthControl.vatAmountWithRate': 'Moms {{amount}} ({{rate}} %)',
  'ap.monthControl.vatAmountMissing': 'Momsbelopp hittades inte ({{rate}} %)',
  'ap.monthControl.invoiceNumber': 'Faktura {{number}}',
  'ap.monthControl.linkedBankLineAmount': 'bankrad {{amount}}',
  'ap.monthControl.reopenNote': 'Bankraden har öppnats igen. Kontrollera och godkänn på nytt för att bokföra.',
  'ap.monthControl.reopenSuccess': 'Bankraden har öppnats igen',
  'ap.monthControl.reopenError': 'Kunde inte öppna bankraden igen.',
  'ap.monthControl.reopenMatchSuccess': 'Kopplingen har öppnats igen. Originalposten har inte ändrats.',
  'ap.monthControl.reopenMatchError': 'Kunde inte öppna kopplingen igen.',
  'ap.monthControl.moreMenu.trigger': 'Annat',
  'ap.monthControl.moreMenu.close': 'Stäng meny',
  'ap.monthControl.choice.asset': 'Tillgång',
  'ap.monthControl.contact.customerLabel': 'Kunden',
  'ap.monthControl.contact.supplierLabel': 'Leverantören',
  'ap.monthControl.contact.requiredBeforeApprove': '{{contact}} måste sparas innan raden kan godkännas.',
  'ap.monthControl.action.reopen': 'Öppna igen',
  'ap.monthControl.action.correct': 'Korrigera',
  'ap.monthControl.action.reverse': 'Återför',
  'ap.monthControl.action.approve': 'Godkänn',
  'ap.monthControl.asset.reconciledNote': 'Avstämd mot registrerad tillgång: {{description}}',
  'ap.monthControl.asset.linkedSuccess': 'Tillgången har kopplats till bankraden',
  'ap.monthControl.asset.linkError': 'Tillgången sparades, men bankraden kunde inte kopplas.',
  'ap.monthControl.receipt.fallbackName': 'Verifikation',
  'ap.monthControl.receipt.view': 'Visa verifikation',
  'ap.monthControl.receipt.duplicateNote': '{{label}}. Godkänn kopplingen för att slutföra bankraden utan ny bokföring.',
  'ap.monthControl.receipt.detachTitle': 'Tar bara bort kopplingen. Verifikationen läggs tillbaka i inkorgen.',
  'ap.monthControl.receipt.detach': 'Koppla från',
  'ap.monthControl.receipt.rowLabel': 'Verifikation {{number}}',
  'ap.monthControl.contact.supplierNameRequired': 'Leverantörsnamn måste fyllas i.',
  'ap.monthControl.contact.customerNameRequired': 'Kundnamn måste fyllas i.',
  'ap.monthControl.contact.supplierRegistryUnavailable': 'Leverantörsregistret är inte tillgängligt.',
  'ap.monthControl.contact.customerRegistryUnavailable': 'Kundregistret är inte tillgängligt.',
  'ap.monthControl.contact.supplierSaved': 'Leverantören har sparats.',
  'ap.monthControl.contact.customerSaved': 'Kunden har sparats.',
  'ap.monthControl.contact.supplierSaveError': 'Kunde inte spara leverantören.',
  'ap.monthControl.contact.customerSaveError': 'Kunde inte spara kunden.',
  'ap.monthControl.contact.updateSupplierTitle': 'Uppdatera leverantör',
  'ap.monthControl.contact.newSupplierTitle': 'Ny leverantör',
  'ap.monthControl.contact.editCustomerTitle': 'Redigera kund',
  'ap.monthControl.contact.newCustomerTitle': 'Ny kund',
  'ap.monthControl.contact.saving': 'Sparar...',
  'ap.monthControl.contact.update': 'Uppdatera',
  'ap.monthControl.contact.save': 'Spara',
  'ap.monthControl.contact.saved': 'Sparad',
  'ap.monthControl.contact.archived': 'Arkiverad',
  'ap.monthControl.contact.notSavedOptional': 'Inte sparad · valfritt',
  'ap.monthControl.contact.edit': 'ändra',
  'ap.monthControl.contact.add': 'Lägg till',
  'ap.monthControl.contact.saveSupplier': 'Spara leverantör',
  'ap.monthControl.summary.stick': 'Fäst toppkortet när du scrollar',
  'ap.monthControl.summary.unstick': 'Lossa toppkortet',
  'ap.monthControl.summary.expand': 'Visa hela toppkortet',
  'ap.monthControl.summary.collapse': 'Minimera toppkortet',
  'ap.monthControl.summary.opening': 'Ingående',
  'ap.monthControl.summary.closing': 'Utgående',
  'ap.monthControl.summary.deviation': 'Avvikelse',
  'ap.monthControl.summary.remaining': 'Återstår',
  'ap.monthControl.summary.bankLines': 'Bankrader',
  'ap.monthControl.summary.allHandled': 'Alla hanterade',
  'ap.monthControl.summary.remainingLinesOne': '{{count}} rad',
  'ap.monthControl.summary.remainingLinesMany': '{{count}} rader',
  'ap.whatShouldDo': 'Vad ska SuperPlumma göra?',
  'ap.openBankingHelp': 'SuperPlumma hämtar dina banktransaktioner automatiskt via en säker bankanslutning (Open Banking) och kopplar dem mot verifikationer. Utan anslutning måste du ladda upp kontoutdrag manuellt.',
  'ap.dataExists': 'Data finns',
  'ap.notConnected': 'Inte ansluten',
  'ap.switchBank': 'Byt bank',
  'ap.connectBank': 'Anslut bank',
  'ap.monthPickerHelp': 'Välj vilken månad du vill arbeta med. Listan visar bara arbete som hör till den månaden. Grön bock betyder att inget återstår; röd betyder att månaden har passerat med något ogjort.',
  'ap.monthOverview': 'Månadsöversikt',
  'ap.prevMonth': 'Föregående månad',
  'ap.nextMonth': 'Nästa månad',
  'ap.noActiveAgents': 'Inga aktiva agenter',
  'ap.activateAgents': 'Aktivera agenter',
  'ap.monthSummaryHelp': 'Arbete för vald månad och uppföljning som gäller hela året.',
  'ap.agents': 'Agenter',
  'ap.agentCount': '{{count}} agent',
  'ap.agentCountPlural': '{{count}} agenter',
  'ap.totalTasksHelp': 'Antal agenter du faktiskt hittar i listan nedan. Agenter som har kontrollerat och inte hittat något är inte med.',
  'ap.readyForApproval': 'Att kontrollera',
  'ap.readyForApprovalHelp': 'Uppgifter som väntar på dig — antingen för att något måste kontrolleras eller för att genomgången saknar en signatur. De är inte klara förrän du har tittat på dem.',
  'ap.approvedHelp': 'Uppgifter som är kontrollerade eller godkända. En godkänd kontroll betyder inte att något är bokfört, skickat eller inlämnat. Se status och detaljer på uppgiften.',
  'ap.approveAllHelp': 'Godkänner de enskilda förslag som AI Redovisningskonsult har bedömt som klara — inte månaden. Bokföringen sker efteråt med en separat Bokför-knapp.',
  'ap.approveAllGreen': 'Godkänn klara',
  'ap.approveProposals': 'Godkänn {{count}} förslag',
  'ap.approveAndBookProposals': 'Godkänn och bokför {{count}} förslag',
  'ap.book': 'Bokför {{count}} förslag',
  'ap.bookHelp': 'För in de godkända förslagen i bokföringen. Det här är den enda knappen som ändrar siffrorna, och den kan inte ångras med ett klick.',
  'ap.nothingToCheck': 'Inget att kontrollera',
  'ap.autoApproved': 'Inga kontrollpunkter',
  'ap.autoApprovedDetail': 'Inget att kontrollera',
  'ap.agent.beforeBank.title': 'Bankavstämningen startar senare än {{month}}',
  'ap.agent.beforeBank.desc': 'Bankkontot har ingående saldo {{date}}, och Plumme stämmer av från dagen efter.',
  'ap.agent.beforeBank.descNoDate': 'Bankkontot stäms av först från ett senare datum.',
  'ap.agent.beforeBank.detail': 'Datumet står på bankkontot i Inställningar. Om Plumme ska stämma av även den här månaden måste startdatumet sättas tidigare och kontoutdraget laddas upp i Bank.',
  'ap.agent.beforeBank.action': 'Öppna bank',
  'ap.monthImported': 'Bokförd i ett annat system',
  'ap.monthOverdue': 'En tidsfrist i den här månaden har passerats',
  'ap.monthReviewHint': 'Inte klar — något återstår i månaden',
  'ap.monthReviewed': '{{month}} är genomgången',
  'ap.agent.imported.title': '{{month}} är bokförd i ett annat system',
  'ap.agent.imported.desc': 'Bokföringen togs över senare. AI Redovisningskonsult har inte kontrollerat den här månaden.',
  'ap.agent.imported.detail': 'Siffror och verifikationer för perioden finns i importarkivet. De måste kontrolleras mot det gamla systemet, inte mot Plumme.',
  'ap.agent.imported.action': 'Öppna arkivet',
  'ap.agent.invoice.titleEmpty': 'Inga fakturor under {{year}}',
  'ap.agent.invoice.descEmpty': 'Inga fakturor är registrerade i Plumme för perioden, så det finns inget att kontrollera.',
  'ap.agent.quality.titleEmpty': 'Inga inköp under {{year}}',
  'ap.agent.quality.descEmpty': 'Inga inköp är registrerade i Plumme för perioden, så det finns inget att kontrollera.',
  'ap.agent.match.titleEmpty': 'Inga bankrader under {{year}}',
  'ap.agent.match.descEmpty': 'Inget kontoutdrag täcker perioden, så det finns inget att koppla.',
  'ap.agent.inbox.detailHistoric': '{{count}} av verifikationerna är daterade innan bokföringen togs över. De är troligen redan bokförda i det gamla systemet och bokförs inte härifrån — de måste kopplas som dokumentation.',
  'ap.agent.dunning.detailImported': '{{count}} av posterna kommer från bokföringsimporten och finns inte i fakturalistan. Plumme kan varken skicka dem eller skicka påminnelser — de måste följas upp i det gamla systemet, eller registreras som reglerade här.',
  'ap.agent.dunning.lineImported': 'Från bokföringsimporten · faktura {{num}} · kan inte påminnas från Plumme',
  'ap.agent.dunning.importedParty': 'Kund från importen',
  'ap.require.noEmployees': 'Inga aktiva anställda är registrerade.',
  'ap.require.noVat': 'Företaget är inte momsregistrerat.',
  'ap.yearScope': 'Gäller hela året',
  'ap.yearScopeHelp': 'Arbete som inte hör till en enskild månad — förfallna fordringar, tidsfrister, register och bokslut.',
  'ap.showAllYearTasks': 'Visa alla ({{count}})',
  'ap.showFewerYearTasks': 'Visa färre',
  'ap.monthEmpty': 'Inget återstår i {{month}}.',
  'ap.agent.reconcile.titleMonth': '{{month}} är inte avstämd',
  'ap.agent.reconcile.titleMonthDone': '{{month}} är avstämd',
  'ap.agent.reconcile.titleMonthOpen': '{{month}} är inte avslutad än',
  'ap.agent.reconcile.descMonth': 'Kontoutdraget för driftskontot för {{month}} är inte bokfört och arkiverat i Bank.',
  'ap.agent.reconcile.descMonthDone': 'Kontoutdraget för driftskontot för {{month}} är bokfört och arkiverat.',
  'ap.agent.reconcile.descMonthOpen': 'Månaden stäms av när den är avslutad och kontoutdraget har importerats.',
  'ap.agent.reconcile.waitingReason': 'Väntar på månadsskiftet',
  'ap.agent.match.titleWaiting': '{{month}} är inte avslutad än',
  'ap.agent.match.descWaiting': 'Verifikationsagenten startar bankkontrollen när månaden är avslutad och kontoutdraget kan importeras.',
  'ap.agent.match.detailWaiting': 'Inget kontoutdrag saknas än. Uppgiften blir aktuell efter månadsskiftet.',
  'ap.agent.payroll.titleWaiting': 'Lön för {{period}} avvaktar',
  'ap.agent.payroll.descWaiting': 'Perioden har inte börjat än. Löneagenten följer upp när månaden är aktuell.',
  'ap.agent.payroll.waitingReason': 'Väntar på att perioden ska börja',
  'ap.agent.payroll.titleReady': 'Lönekörning för {{period}} kan skapas',
  'ap.agent.payroll.descReady': 'Fasta lönerader är klara att skapas som ett utkast för kontroll.',
  'ap.agent.reconcile.disabledTitle': 'Avstämning är inte aktiv',
  'ap.agent.reconcile.disabledDesc': 'Inga aktiva bankkonton är inställda för avstämning.',
  'ap.agent.reconcile.disabledDetail': 'Detta passar företag som använder ett privat konto och har valt att kontot inte ska stämmas av i Bank.',
  'ap.agent.match.disabledTitle': 'Verifikationsmatchning är inte aktiv',
  'ap.agent.match.disabledDesc': 'Inga aktiva bankkonton är inställda för avstämning.',
  'ap.agent.match.disabledDetail': 'När företaget använder ett privat konto utan bankavstämning finns det inget kontoutdrag för driftskontot att koppla verifikationer mot.',
  'ap.showDetails': 'Visa detaljer',
  'ap.showTask': 'Visa uppgift',
  'ap.quiet.title': '{{count}} agenter hittade inget att kontrollera',
  'ap.quiet.titleClear': '{{count}} agenter hittade inget att följa upp',
  'ap.quiet.titleOne': '{{agent}} hittade inget att kontrollera',
  'ap.quiet.titleClearOne': '{{agent}} hittade inget att följa upp',
  'ap.quiet.someApproved': '{{count}} godkända',
  'ap.require.noBankReconciliation': 'Inga aktiva bankkonton är inställda för avstämning.',
  'ap.agent.awaitBank.title': 'Väntar på kontoutdrag för {{month}}',
  'ap.agent.awaitBank.desc': 'Ladda upp kontoutdraget för perioden. Utan det finns det inga bankrader att koppla verifikationer mot eller stämma av.',
  'ap.agent.awaitBank.detail': 'Bankarbetet sker i ordning: kontoutdraget måste in innan verifikationerna kan kopplas och månaden kan stämmas av.',
  'ap.agent.awaitBank.action': 'Öppna bank',
  'ap.agent.awaitBank.reason': 'Saknar kontoutdrag för perioden',
  'ap.uploadStatement': 'Ladda upp kontoutdrag',
  'ap.agent.awaitBank.descAccounts': '{{count}} konton saknar kontoutdrag för perioden.',
  'ap.agent.awaitBank.reasonAccounts': 'Saknar kontoutdrag för {{count}} konton',
  'ap.agent.awaitBank.account': 'Bankkonto',
  'ap.taskColumnHelp': 'Vad SuperPlumma har gjort — t.ex. bokfört banktransaktioner, kopplat verifikationer, registrerat tillgångar eller kört lön.',
  'ap.task': 'Uppgift',
  'ap.descriptionColumn': 'Beskrivning',
  'ap.statusColumn': 'Status',
  'ap.actionColumn': 'Åtgärd',
  'ap.statusColumnHelp': 'Grönt betyder à jour. Gult betyder att något bör kontrolleras innan du går vidare. Kontrollera de markerade raderna.',
  'ap.actionColumnHelp': 'Tryck på «Visa» för att se underlaget bakom uppgiften, eller «Öppna» för att gå till sidan där du kan arbeta vidare.',
  'ap.task.actionLabel': 'Gå till',
  'ap.task.detailsLabel': 'Se detaljer',
  'ap.agent.bank.disabledTitle': 'Bankavstämning är inte aktiv',
  'ap.agent.bank.disabledDesc': 'Inga aktiva bankkonton är inställda för avstämning.',
  'ap.agent.bank.disabledDetail': 'Detta passar företag som använder ett privat konto och har valt att kontot inte ska stämmas av i Bank.',
  'ap.agent.bank.action': 'Öppna bank',
  'ap.agent.bank.reopenDetail': 'Öppna avstämningen igen om något måste rättas. Då visas bankarbetsytan i samma fönster.',
  'ap.agent.bank.title': 'Bankavstämning: {{count}} rader behöver kontrolleras',
  'ap.agent.bank.titleNoStatement': 'Bankavstämningen saknar kontoutdrag',
  'ap.agent.bank.desc': '{{handled}} rader är behandlade, {{remaining}} återstår.',
  'ap.agent.bank.descNoStatement': 'Importera ett kontoutdrag innan AI Redovisningskonsult kan föreslå bankavstämning.',
  'ap.agent.bank.detail': 'AI Redovisningskonsult visar bankrader som inte är färdigavstämda. Själva bokföringen måste fortfarande godkännas i bankvyn.',
  'ap.agent.bank.detailNoStatement': 'Inget kontoutdrag är tillgängligt för perioden.',
  'ap.agent.bank.actionImport': 'Importera bank',
  'ap.agent.bank.blockedReason': 'Saknar bankdata',
  'ap.agent.bank.archiveLabel': 'Arkivera {{count}} färdiga kontoutdrag',
  'ap.agent.bank.archiveConfirmTitle': 'Arkivera färdigbehandlade kontoutdrag',
  'ap.agent.bank.archiveConfirmWarn': 'Kontoutdragen flyttas till arkivet och låser perioden. De kan öppnas igen från Bank.',
  'ap.agent.bank.archiveCheckedNote': 'Bara kontoutdrag där alla rader är behandlade, allt är bokfört och saldot stämmer. Allt annat måste du göra från «Stäm av och bokför».',
  'ap.agent.bank.archiveDoneLabel': 'kontoutdrag arkiverade',
  'ap.agent.vat.termWithNumber': 'period {{n}}',
  'ap.agent.vat.termFallback': 'momsperioden',
  'ap.agent.vat.termWithPeriod': 'Moms {{period}}',
  'ap.agent.vat.termGeneric': 'Momsperiod',
  'ap.agent.vat.disabledTitle': 'Momsagenten är inte aktiv',
  'ap.agent.vat.disabledDesc': 'Företaget står inte som momsregistrerat i inställningarna.',
  'ap.agent.vat.disabledDetail': 'AI Redovisningskonsult visar inte momsinlämning förrän företaget är momsregistrerat.',
  'ap.agent.vat.noTermTitle': 'Ingen momsperiod den här månaden',
  'ap.agent.vat.noTermDesc': 'Företagets momsperiod har ingen inlämning kopplad till vald månad.',
  'ap.agent.vat.noTermDetail': 'Fristagenten varnar fortfarande när momsfristen närmar sig. Själva momsperioden finns under Inlämningar.',
  'ap.agent.vat.openFilings': 'Öppna inlämningar',
  'ap.agent.vat.titleOverdueOne': '{{count}} momsperiod har passerat tidsfristen',
  'ap.agent.vat.titleOverdueMany': '{{count}} momsperioder har passerat tidsfristen',
  'ap.agent.vat.titleCandidatesOne': '{{count}} momsperiod måste deklareras',
  'ap.agent.vat.titleCandidatesMany': '{{count}} momsperioder måste deklareras',
  'ap.agent.vat.titleWaiting': 'Moms {{term}} är inte klar ännu',
  'ap.agent.vat.titleUpToDate': 'Momsen är à jour',
  'ap.agent.vat.descCandidates': 'Momssiffrorna är beräknade utifrån bokföringen och måste kontrolleras före inlämning.',
  'ap.agent.vat.descWaiting': 'Perioden omfattar {{period}} och har tidsfrist {{due}}.',
  'ap.agent.vat.descDelivered': 'MVA-meldingen är inlämnad. Den visas fortfarande här så att du kan öppna perioden om något behöver korrigeras.',
  'ap.agent.vat.descNoneOpen': 'Inga öppna momsperioder hittades.',
  'ap.agent.vat.detail': 'AI Redovisningskonsult använder momssiffrorna i Plumme. Inlämning och betalning måste fortfarande godkännas innan något skickas.',
  'ap.agent.vat.dueNote': 'Tidsfrist {{due}}',
  'ap.agent.vat.paidNote': 'Inlämnad och betald',
  'ap.agent.vat.filedNote': 'Inlämnad',
  'ap.agent.asset.title': 'Bedöm {{count}} köp som tillgång',
  'ap.agent.asset.titleEmpty': 'Inga tillgångsförslag',
  'ap.agent.asset.desc': 'Köp bokförda på tillgångskonto saknas i tillgångsregistret.',
  'ap.agent.asset.descEmpty': 'Inga köp i perioden behöver bedömas.',
  'ap.agent.asset.detail': 'Registrerade tillgångar följs upp i tillgångsregistret och i bokslutet.',
  'ap.agent.asset.action': 'Öppna tillgångar',
  'ap.agent.asset.registerLabel': 'Registrera {{count}} inventarier',
  'ap.agent.asset.registerConfirmTitle': 'Registrera inventarier',
  'ap.agent.asset.registerConfirmWarn': 'Köpen får ett avskrivningsunderlag. Belopp, datum, konto och moms på själva köpet ändras inte.',
  'ap.agent.asset.registerCheckedNote': 'Bara köp där kontot avgör saldogruppen registreras. Är gruppen oklar måste du välja själv — fel grupp ger fel avskrivningssats alla framtida år.',
  'ap.agent.asset.registerDoneLabel': 'inventarier registrerade',
  'ap.agent.asset.lineFallback': 'Köp',
  'ap.agent.payroll.titleOpenOne': '{{count}} lönekörning väntar',
  'ap.agent.payroll.titleOpenMany': '{{count}} lönekörningar väntar',
  'ap.agent.payroll.titleNoRuns': 'Lön har inga öppna körningar',
  'ap.agent.payroll.descOpen': 'Lönen måste kontrolleras och godkännas i lönevyn.',
  'ap.agent.payroll.descApprovedOne': '{{count}} lönekörning är godkänd eller betald.',
  'ap.agent.payroll.descApprovedMany': '{{count}} lönekörningar är godkända eller betalda.',
  'ap.agent.payroll.detail': 'AI Redovisningskonsult visar lönestatus från Plumme. Godkännande och betalning görs i lönevyn. Inlämning av A-melding till Altinn är inte ansluten ännu.',
  'ap.agent.payroll.action': 'Öppna lön',
  'ap.agent.payroll.lineFallback': 'Lönekörning',
  'ap.agent.payroll.generateLabel': 'Skapa lönekörning för {{period}}',
  'ap.agent.payroll.generateConfirmTitle': 'Skapa lönekörning som utkast',
  'ap.agent.payroll.generateConfirmWarn': 'Körningen skapas som utkast från fasta lönerader. Inget betalas ut eller bokförs — du måste öppna lön, kontrollera varje anställd och godkänna själv.',
  'ap.agent.payroll.generateCheckedNote': 'Reseersättningar tas inte med. De måste läggas till manuellt så att ingen ersättning betalas ut utan att resan har bedömts.',
  'ap.agent.payroll.generateDoneLabel': 'lönekörning skapad',
  'ap.workspace.doneCount': '{{count}} godkända',
  'ap.workspace.doneNone': 'Inga godkända ännu',
  'ap.workspace.readyCountOne': '{{count}} är klar',
  'ap.workspace.readyCountMany': '{{count}} är klara',
  'ap.workspace.inboxReviewCount': '{{count}} rader måste kontrolleras',
  'ap.workspace.remainingCount': '{{count}} återstår',
  'ap.workspace.reviewToControl': '{{count}} att kontrollera',
  'ap.workspace.assetDetail': 'Samma verifikation ägs av bokföringskön. Välj kostnadsföring eller inventarie här; köpet bokförs bara en gång.',
  'ap.workspace.queueDetail': 'Förslagen är grupperade per agent. Öppna listan för att kontrollera och redigera före godkännande.',
  'ap.workspace.openWorklist': 'Öppna arbetslista',
  'ap.workspace.proposalModalTitle': 'Kontrollera förslag · {{title}}',
  'ap.workspace.close': 'Stäng',
  'ap.workspace.saveProposal': 'Spara förslag',
  'ap.workspace.proposalSaveNote': 'Att spara ändrar förslaget, inte bokföringen. Ett tidigare godkännande upphävs när förslaget ändras.',
  'ap.workspace.accountLabel': 'Konto',
  'ap.workspace.vatRateLabel': 'Momssats',
  'ap.workspace.paidWithLabel': 'Betald med',
  'ap.workspace.paidWithCompany': 'Företagskonto',
  'ap.workspace.paidWithPrivate': 'Privat',
  'ap.workspace.paidWithCash': 'Kontant',
  'ap.workspace.needsReviewOption': 'Måste kontrolleras',
  'ap.workspace.treatmentLabel': 'Hantering',
  'ap.workspace.treatmentPlaceholder': 'Välj hantering',
  'ap.workspace.treatmentExpense': 'Kostnadsför hela köpet',
  'ap.workspace.treatmentAsset': 'Registrera som inventarie',
  'ap.workspace.balanceGroupLabel': 'Saldogrupp',
  'ap.workspace.balanceGroupPlaceholder': 'Välj saldogrupp',
  'ap.workspace.balanceGroupA': 'a · kontorsmaskiner m.m. (30 %)',
  'ap.workspace.balanceGroupC': 'c · skåpbilar m.m. (24 %)',
  'ap.workspace.balanceGroupD': 'd · inventarier m.m. (20 %)',
  'ap.workspace.typeLabel': 'Typ',
  'ap.workspace.bookingTypePurchase': 'Köp',
  'ap.workspace.bookingTypeSale': 'Försäljning',
  'ap.workspace.bookingTypeUnknown': 'Måste hanteras i Bank',
  'ap.workspace.classificationLabel': 'Klassificering',
  'ap.workspace.classificationBusiness': 'Företag',
  'ap.workspace.mileageModalTitle': 'Redigera resa',
  'ap.workspace.saveTrip': 'Spara resa',
  'ap.workspace.dateLabel': 'Datum',
  'ap.workspace.purposeLabel': 'Syfte',
  'ap.workspace.fromLabel': 'Från',
  'ap.workspace.toLabel': 'Till',
  'ap.workspace.kilometersLabel': 'Kilometer',
  'ap.suggestionOverrideNote': 'Du kan ändra konto, moms och belopp innan du godkänner. Ändringen åsidosätter autopilotens förslag.',
  'ap.payslipFor': 'Lönebesked för {{name}}',
  'ap.payslipEditHelpHourly': 'Snabb korrigering: justera belopp eller antal timmar. Resten av lönebeskedet räknas om.',
  'ap.payslipEditHelpFixed': 'Snabb korrigering: justera belopp. Resten av lönebeskedet räknas om.',
  'ap.payslipBookedHelp': 'SuperPlumma har bokfört lönen på 5000, förskottsskatt på 2600 och arbetsgivaravgift på 2770.',
  'ap.payslipCalculatedGross': 'Beräknad bruttolön:',
  'ap.payslipHourlyLabel': 'Timlön',
  'ap.payslipFixedLabel': 'Fast lön',
  'ap.contactsNewSuppliersTitle': 'Nya leverantörer',
  'ap.contactsCreateSelected': 'Skapa valda ({{count}})',
  'ap.contactsProposedCount': '{{count}} {{noun}} föreslagna',
  'ap.contactsFoundNote': 'SuperPlumma hittade konteringar utan registrerad {{noun}}. Spara dem i {{list}} så kopplas framtida konteringar automatiskt.',
  'ap.contactsInclude': 'Ta med',
  'ap.openingVoucher': 'Öppnar {{name}}',
  'ap.sendReminder': 'Skicka påminnelse',
  'ap.sendInvoice': 'Skicka faktura',
  'ap.clickToSeePayslipLines': 'Klicka för att se lönerader',
  'ap.clickToEditProposal': 'Klicka för att redigera förslaget',
  'ap.clickToOpenWorkArea': 'Klicka för att öppna arbetsytan',
  'ap.ignoreThisMonth': 'Ignorera den här månaden',
  'ap.entryCancelled': 'Konteringen makulerades',
  'ap.entryUpdated': 'Kontering uppdaterad 🟣',
  'ap.approvalReopened': 'Godkännandet är upphävt. Uppgiften är öppen igen.',
  'ap.reopenTaskError': 'Kunde inte öppna uppgiften igen.',
  'ap.proposalsBookedToast': '{{count}} förslag har godkänts och bokförts.',
  'ap.approveBookError': 'Kunde inte godkänna och bokföra förslagen.',
  'ap.proposalUpdatedToast': 'Förslaget har uppdaterats och måste godkännas på nytt.',
  'ap.lineHiddenToast': 'Raden är dold för den här månaden och kommer tillbaka nästa månad om den fortfarande är öppen.',
  'ap.voucherLinkedToast': 'Verifikationen har kopplats till bankraden. Förslaget bedöms på nytt.',
  'ap.mileageFillRequired': 'Fyll i datum, från, till, syfte och kilometer.',
  'ap.mileageSaveUnavailable': 'Det går inte att spara körjournalen just nu.',
  'ap.mileageUpdatedToast': 'Resan har uppdaterats.',
  'ap.noActiveAgentsText': 'SuperPlumma står redo, men inga agenter är aktiverade just nu. Aktivera de agenter du vill använda i inställningarna ovan, så sätter teamet igång med din bokföring.',
  'ap.vatSurface.emptyTitle': 'Ingen momsperiod att deklarera',
  'ap.vatSurface.emptyDesc': 'Alla perioder under året är markerade som inlämnade.',
  'ap.vatSurface.pickPrompt': 'Välj vilken momsperiod du vill kontrollera och skicka in.',
  'ap.vatSurface.termFallback': 'Momsperiod',
  'ap.vatSurface.title': 'MVA-melding',
  'ap.vatSurface.openSubmissions': 'Öppna inlämningar',
});
